export const queriesPreviewFallback: Record<string, any> = {
  es: [
    {
      query: 'Bestsellers',
      title: 'Los productos más vendidos',
    },
  ],
  it: [
    {
      query: 'Bestsellers',
      title: 'I prodotti più venduti',
    },
  ],
  de: [
    {
      query: 'Bestsellers',
      title: 'Die meistverkauften Produkte',
    },
  ],
  fr: [
    {
      query: 'Bestsellers',
      title: 'Les produits les plus vendus',
    },
  ],
  pt: [
    {
      query: 'Bestsellers',
      title: 'Os produtos mais vendidos',
    },
  ],
  en: [
    {
      query: 'Bestsellers',
      title: 'Best-selling products',
    },
  ],
}
